module.exports = __webpack_public_path__ + "static/bebe-img-5d0caacb9cd4f419b18509cbb9c617b9.jpg";